import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExtraBalanceHeaderBottom } from '../../styles/ExtraBalanceStyled';
import {
  BundleDetailsHeaderTitleStyled as BundleDetailsHeaderTitle,
  BundleDetailsTabsWrapperStyled as BundleDetailsTabsWrapper,
  BundleDetailsTabsListStyled as BundleDetailsTabsList,
  BundleDetailsTabStyled as BundleDetailsTab,
  BundleDetailsTabPanelWrapperStyled as BundleDetailsTabPanelWrapper,
  BundleDetailsTabPanelContentStyled as BundleDetailsTabPanelContent,
} from './styles/BundleDetailsStyled';
import BundleDetailsTabContent from './BundleDetailsTabContent';
import AppContext from '../../../App/AppContext';
import HomeService from '../../../../services/Home';
import Loading from '../../../General/Loading';
import ExtraBalanceError from '../../ExtraBalanceError/ExtraBalanceError';

const BundleDetails = ({ categories, setOffer, closePanel }) => {
  const { balanceData } = useContext(AppContext);

  const [actualBalance, setActualBalance] = useState(balanceData);
  const [balanceError, setBalanceError] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(false);

  const loadBalance = () => {
    setBalanceLoading(true);
    HomeService.getBalance()
      .then(([dataBalance]) => {
        setActualBalance(dataBalance);
        setBalanceError(false);
        setBalanceLoading(false);
      })
      .catch(() => {
        setBalanceError(true);
        setBalanceLoading(false);
      });
  };

  useEffect(() => {
    if (!actualBalance) {
      loadBalance();
    }
  }, []);

  return (
    <>
      {!balanceError || balanceLoading ? (
        <BundleDetailsTabsWrapper defaultValue={0}>
          <ExtraBalanceHeaderBottom>
            <BundleDetailsHeaderTitle>
              ¿Te quedaste sin saldo, datos o minutos? <br /> ¡Te damos una
              ayuda extra!
            </BundleDetailsHeaderTitle>
            <BundleDetailsTabsList variant="bar">
              {categories.map(category => (
                <BundleDetailsTab key={category.label}>
                  {category.label.toUpperCase()}
                </BundleDetailsTab>
              ))}
            </BundleDetailsTabsList>
          </ExtraBalanceHeaderBottom>
          <BundleDetailsTabPanelWrapper>
            {balanceLoading && <Loading />}
            {!balanceLoading &&
              !balanceError &&
              actualBalance &&
              categories.map((category, index) => (
                <BundleDetailsTabPanelContent
                  key={category.label}
                  value={index}
                >
                  <BundleDetailsTabContent
                    label={category.label.toUpperCase()}
                    data={category.offers}
                    actualBalance={actualBalance}
                    setOffer={setOffer}
                  />
                </BundleDetailsTabPanelContent>
              ))}
          </BundleDetailsTabPanelWrapper>
        </BundleDetailsTabsWrapper>
      ) : (
        <>
          <ExtraBalanceHeaderBottom />
          <ExtraBalanceError
            serviceError
            retry={loadBalance}
            closePanel={closePanel}
            markOptions={{
              event: 'pagina-virtual',
              page: '/extrasaldo/error-servicio-home',
              pagename: 'Extrasaldo - Error Servicio - Home',
            }}
          />
        </>
      )}
    </>
  );
};

BundleDetails.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  setOffer: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

export default BundleDetails;
